/* eslint-disable unicorn/filename-case -- kebab-case matches its sibling builder
   DimeDataTable/selection-column.tsx: this file exports a ColumnDef factory function, not a
   React component, so the PascalCase-for-components rule does not apply. */
import type { RowData } from '@tanstack/react-table';
import * as React from 'react';

import type { ParentColumnDef, ParentRow } from './DimeNestedTable.types.js';
import { DimeNestedTableToggle } from './DimeNestedTableToggle.js';
import { NestedTableExpandAllHeader } from './NestedTableExpandAllHeader.js';

export function buildExpandColumn<TParent extends RowData>(
  onToggle: (row: ParentRow<TParent>) => void,
): ParentColumnDef<TParent, unknown> {
  return {
    id: 'expand',
    enableSorting: false,
    // Mirrors selection-column.tsx: a structural column must never be hidden from the Columns menu.
    enableHiding: false,
    header: () => <NestedTableExpandAllHeader />,
    cell: ({ row }) =>
      row.getCanExpand() ? (
        <DimeNestedTableToggle isExpanded={row.getIsExpanded()} onClick={() => onToggle(row)} />
      ) : null,
  };
}
